import React, { useState } from 'react';
import { ImagePlus } from 'lucide-react';
import GalleryPicker from './GalleryPicker';

// A field showing an image URL with a preview and a "Choose from gallery" button
// that opens the GalleryPicker (with tag filter + analysed upload).
export default function ImageField({ value, onChange, placeholder = 'Image URL (optional)', testid = 'image-field' }) {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-2">
        {value ? <img src={value} alt="" className="w-10 h-10 rounded object-cover border" style={{ borderColor: 'rgba(0,0,0,0.15)' }} /> : <div className="w-10 h-10 rounded border flex items-center justify-center" style={{ borderColor: 'rgba(0,0,0,0.15)' }}><ImagePlus size={16} style={{ color: 'var(--olive)' }} /></div>}
        <input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={`${testid}-input`} className="flex-1 px-3 py-2 rounded border text-sm" style={{ borderColor: 'rgba(0,0,0,0.2)' }} />
        <button type="button" onClick={() => setOpen(true)} data-testid={`${testid}-choose`} className="inline-flex items-center gap-1 px-3 py-2 rounded text-sm font-title whitespace-nowrap" style={{ background: 'var(--sage)', color: 'var(--ink)' }}>
          <ImagePlus size={14} /> Choose
        </button>
      </div>
      <GalleryPicker open={open} onClose={() => setOpen(false)} onSelect={(url) => onChange(url)} />
    </div>
  );
}
